import type { DropdownOption, EntityRecord, PageQuery, PagedResult } from "../../types/api.types.js";

export type CmtsComplaintRecord = EntityRecord;
export type CmtsComplaintDetail = EntityRecord;
export type CmtsAllowedAction = EntityRecord & { readonly actionCode?: string; readonly code?: string; readonly label?: string; readonly requiresConfirmation?: boolean };
export type CmtsTimelineItem = EntityRecord;
export type CmtsLinkedLifecycleRecord = EntityRecord;
export type CmtsEvidenceRecord = EntityRecord;

export type CmtsComplaintListQuery = PageQuery & {
  readonly filters?: Readonly<Record<string, string | number | boolean | null | undefined>> | undefined;
};

export type CmtsComplaintDropdowns = {
  readonly sourceId: readonly DropdownOption[];
  readonly complaintTypeId: readonly DropdownOption[];
  /** Backend create-schema compatibility alias for ComplaintTypeId. Do not emit issueTypeId in create payloads. */
  readonly issueTypeId?: readonly DropdownOption[] | undefined;
  readonly categoryId: readonly DropdownOption[];
  readonly subCategoryId: readonly DropdownOption[];
  readonly severityId: readonly DropdownOption[];
  readonly priorityId: readonly DropdownOption[];
  readonly organizationUnitId: readonly DropdownOption[];
  readonly customerId?: readonly DropdownOption[] | undefined;
  readonly supplierId?: readonly DropdownOption[] | undefined;
  /** @deprecated UI-only compatibility alias. Do not emit typeId in backend create payloads. */
  readonly typeId?: readonly DropdownOption[] | undefined;
  /** @deprecated UI-only compatibility alias. Do not emit subcategoryId in backend create payloads. */
  readonly subcategoryId?: readonly DropdownOption[] | undefined;
};

export type CmtsComplaintCreateResult = CmtsComplaintDetail;
export type CmtsComplaintPagedResult = PagedResult<CmtsComplaintRecord>;

export function recordIdOf(record: EntityRecord | null | undefined): string {
  if (!record) return "";
  const value = record.id ?? record.complaintId ?? record.rcaId ?? record.capaId ?? record.verificationId ?? record.evidenceId;
  return typeof value === "string" || typeof value === "number" ? String(value) : "";
}

export function recordLabelOf(record: EntityRecord | null | undefined, fallback: string): string {
  if (!record) return fallback;
  const value = record.label ?? record.title ?? record.name ?? record.complaintNumber ?? record.code ?? record.id;
  return typeof value === "string" || typeof value === "number" ? String(value) : fallback;
}

export function recordString(record: EntityRecord | null | undefined, keys: readonly string[], fallback = ""): string {
  if (!record) return fallback;
  for (const key of keys) {
    const value = record[key];
    if (typeof value === "string" && value.trim()) return value;
    if (typeof value === "number" && Number.isFinite(value)) return String(value);
  }
  return fallback;
}
